import React from 'react'
import routes from '../../router/routes'
import { strings } from '../../../localization/strings'
import { TextField, Button } from '@material-ui/core'
import { resetPassword } from '../../../helpers/restHelpers'
import Loader from '../../loaders'
import logotipoPudo from '../../../assets/icons/logo-pudo-en-tu-camino.png'

class Component extends React.Component {
    state = {
        loading: false,
        email: '',
        email_isValid: false,
    }

    handleConfirm = () => {
        this.setState({ loading: true })
        resetPassword({ mail: this.state.email })
            .then(() =>
                window.showDialog(
                    {
                        title: strings.resetPasswordRequestSuccessTitle,
                        message: strings.resetPasswordRequestSuccess,
                    },
                    () => this.props.history.replace(routes.logIn.path)
                )
            )
            .catch(() =>
                window.showDialog(
                    {
                        title: null,
                        message: strings.resetPasswordRequestFailed,
                    },
                    () => this.props.history.replace(routes.logIn.path)
                )
            )
    }

    isValidEmail(email) {
        return !!email
    }

    render() {
        return (
            <div>
                {!this.state.loading ? null : <Loader />}

                <div className={'centered-element-container'}>
                    <img src={logotipoPudo} style={{width:'200px', margin:'30px auto'}} onClick={() => this.props.history.push('/')} />
                    <p>{strings.resetPasswordRequestDescription}</p>
                </div>

                <div className={'centered-element-container'}>
                    <TextField
                        id="email"
                        label={strings.resetPasswordRequestEmail}
                        onChange={(ev) =>
                            this.setState({
                                email: ev.target.value,
                                email_isValid: this.isValidEmail(
                                    ev.target.value
                                ),
                            })
                        }
                        type={'text'}
                        value={this.state.email}
                    />
                </div>

                <div className={'centered-element-container'}>
                    <Button
                        disabled={!this.state.email_isValid}
                        onClick={this.handleConfirm}
                        variant="contained"
                        color="primary"
                    >
                        {strings.resetPasswordRequesConfirm}
                    </Button>
                </div>
            </div>
        )
    }
}

export default Component
